import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const FlowContext = createContext();

const LegacyNavigationFlowProvider = ({
  goToHome,
  openFlightSummary,
  children,
}) => {
  const actions = useMemo(
    () => ({ goToHome, openFlightSummary }),
    [goToHome, openFlightSummary],
  );
  return (
    <FlowContext.Provider value={actions}>{children}</FlowContext.Provider>
  );
};

LegacyNavigationFlowProvider.propTypes = {
  children: PropTypes.node,
  goToHome: PropTypes.func.isRequired,
  openFlightSummary: PropTypes.func.isRequired,
};

export const useFlowAction = () => useContext(FlowContext);

export default LegacyNavigationFlowProvider;
